@if (vm$ | async; as vm) {
  <ng-container *transloco="let t; read: 'devices.detail'">
    <ng-container *transloco="let tGlobal; read: 'global'">
      <form [formGroup]="wearingPartForm" class="xs12col" [hidden]="isNew">
        <div class="xs12col">
          <div class="fieldsetWrapper">
            <fieldset class="fieldsetContainer flexRow">
              <div class="titleAdd">
                <h2 class="padding-right-small">{{ t('wearingParts.title') }}</h2>
                <div class="functionContainer">
                  <button
                    kendoButton
                    class="addIcon small"
                    (click)="openWearingPartDialog()"
                    [hidden]="!('Permissions.WearingParts.Create' | permission)">
                    <span class="icon">
                      <img src="../../../assets/icons/add-icon.svg">
                    </span>
                  </button>
                  <div class="flexRow align-center" [hidden]="!('Permissions.WearingParts.Export' | permission)">
                    <button
                      kendoButton
                      loadingIndication="/wearingParts/exportWearingPartsByDevice"
                      class="addIcon small"
                      (click)="exportWearingParts()">
                      <span class="k-button-text">
                        <span class="icon">
                          <img src="../../../assets/icons/upload-icon.svg">
                        </span>
                      </span>
                    </button>
                    <span>{{ t('wearingParts.export') }}</span>
                    <span  class="tooltipContainer">
                      <span [attr.tooltip]="t('wearingParts.tooltipExport')" flow="right" class="tooltipContainer">
                        <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                      </span>
                    </span>
                  </div>
                  <div class="flexRow align-center" [hidden]="!('Permissions.WearingParts.Export' | permission)">
                    <a class="addIcon small" (click)="copyWearingParts(vm.wearingParts)">
                      <span class="k-button-text">
                        <span class="icon">
                          <img src="../../../assets/icons/copy-icon.svg" class="copy">
                        </span>
                      </span>
                    </a>
                    <span>{{ t('wearingParts.copy') }}</span>
                    <span  class="tooltipContainer">
                      <span [attr.tooltip]="t('wearingParts.tooltipCopy')" flow="right" class="tooltipContainer">
                        <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              @if (wearingPartOpened) {
                <kendo-dialog
                  title="{{t('wearingParts.create')}}"
                  (close)="closeWearingPartDialog('cancel')"
                  [minWidth]="250"
                  [width]="450">
                  <kendo-formfield>
                    <kendo-label [for]="wearingPartCategoryId" [text]="t('wearingParts.category')">*</kendo-label>
                    <kendo-dropdownlist
                      [data]="vm.wearingPartCategories"
                      textField="name"
                      valueField="id"
                      [defaultItem]="{ id: null, name: 'Kategorie wählen' }"
                      formControlName ="wearingPartCategoryId"
                      [valuePrimitive]="true"
                      #wearingPartCategoryId>
                    </kendo-dropdownlist>
                  </kendo-formfield>
                  <kendo-formfield [hidden]="editingWearingPart">
                    <kendo-label [for]="productId" [text]="t('wearingParts.product')">*</kendo-label>
                    <kendo-dropdownlist
                      [data]="vm.searchResults"
                      textField="name"
                      valueField="id"
                      [filterable]="true"
                      (filterChange)="onFilter($event)"
                      [defaultItem]="{ id: null, name: 'Artikel wählen', internalNumber: '' }"
                      formControlName="productId"
                      [valuePrimitive]="true"
                      [loading]="vm.productSearchIsLoading"
                      #productId>
                      <ng-template kendoDropDownListItemTemplate let-dataItem>
                        {{ dataItem.name }}
                        @if (dataItem?.internalNumber) {
                          | {{ dataItem.internalNumber }}
                        }
                      </ng-template>
                      <ng-template kendoDropDownListValueTemplate let-selected>
                        {{ selected?.name }}
                        @if (selected?.internalNumber) {
                          | {{ selected?.internalNumber }}
                        }
                      </ng-template>
                    </kendo-dropdownlist>
                  </kendo-formfield>
                  <kendo-formfield>
                    <kendo-label [for]="quantity" [text]="t('wearingParts.quantity')">*</kendo-label>
                    <kendo-numerictextbox
                      formControlName="quantity"
                      [format]="'n0'"
                      [min]="1"
                      #quantity>
                    </kendo-numerictextbox>
                  </kendo-formfield>
                  <kendo-dialog-actions>
                    <button
                      [disabled]="wearingPartForm.invalid || !wearingPartForm.dirty"
                      type="submit"
                      kendoButton
                      (click)="submitWearingPartCreation()"
                      class="buttonPrimary">
                      {{ editingWearingPart ? t('wearingParts.update') : t('wearingParts.submit') }}
                    </button>
                    <button
                      kendoButton
                      (click)="closeWearingPartDialog('no')"
                      class="buttonSecondary">
                      {{t('cancel')}}
                    </button>
                    <button
                      kendoButton
                      class="buttonSecondary"
                      (click)="removeWearingPart()"
                      [hidden]="!editingWearingPart || !('Permissions.WearingParts.Delete' | permission)">
                      <img src="../../../assets/icons/delete-icon.svg">
                    </button>
                  </kendo-dialog-actions>
                </kendo-dialog>
              }
              @for (wearingPart of vm.wearingParts; track wearingPart) {
                <div class="xs12col serviceWrapper">
                  <div class="wearingPartContainer" [class.inactive-product]="!wearingPart.product.isActive">
                    <div class="content xs12col m6col flex-wrap padding-bottom-medium">
                      <div class="xs12col s4col flex-wrap">
                        <span class="fontBold xs12col">{{ t('wearingParts.name') }}</span>
                        <span>{{ wearingPart.product.name }} </span>
                        @if (!wearingPart.product.isActive && wearingPart.product.inactiveReason) {
                          <span class="tooltipContainer">
                            <span [attr.tooltip]="wearingPart.product.inactiveReason" flow="right" class="tooltipContainer">
                              <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                            </span>
                          </span>
                        }
                      </div>
                      <div class="xs12col s4col flex-wrap">
                        <span class="fontBold xs12col">{{ t('wearingParts.internalNumber') }}</span>
                        <span>{{ wearingPart.product.internalNumber }}</span>
                      </div>
                      <div class="xs12col s4col flex-wrap">
                        <span class="fontBold xs12col">{{ t('wearingParts.quantity') }}</span>
                        <span>{{ wearingPart.quantity }}</span>
                      </div>
                    </div>
                    <div class="addWearingPartToCart xs12col m6col padding-bottom-medium">
                      <kendo-numerictextbox
                        [disabled]="wearingPartOpened || !wearingPart.product.isActive"
                        [style.width.px]="80"
                        [autoCorrect]="true"
                        [min]="1"
                        format="n0"
                        [value]="wearingPart.quantity"
                        #productQuantity>
                      </kendo-numerictextbox>
                      <button
                        [disabled]="wearingPartOpened || !wearingPart.product.isActive"
                        kendoButton
                        loadingIndication="/basketitems/createbasketitem"
                        (click)="addToCart(productQuantity.value, wearingPart.product)"
                        class="buttonPrimary "
                      >{{t('wearingParts.addToCart')}}</button>
                    </div>
                    <div class="footer xs12col">
                      <div class="iconItems flexRow">
                        <div class="iconItem padding-right-medium">
                          <img src="../../../assets/icons/category-icon.svg"><span>{{ wearingPart.wearingPartCategory.name }}</span>
                        </div>
                        <div class="iconItem" [hidden]="!wearingPart.location">
                          <img src="../../../assets/icons/cabinet-black-icon.svg"><span>{{ wearingPart.location }}</span>
                        </div>
                      </div>
                      <a
                        [hidden]="!('Permissions.WearingParts.Update' | permission)"
                        (click)="editWearingPart(wearingPart)">
                        <img src="../../../assets/icons/edit-icon.svg">
                      </a>
                    </div>
                  </div>
                </div>
              }
              <div class="xs12col justify-center">
                @if (vm.loading) {
                  <div class="loading-container">
                    <div class="k-loading-color"></div>
                    <kendo-loader type="converging-spinner" size="large"></kendo-loader>
                  </div>
                }
              </div>
            </fieldset>
          </div>
        </div>
      </form>
    </ng-container>
  </ng-container>
}